{
    "testingText": {
        "test": "Esto es una prueba.",
        "Hello": "Hola",
        "Array": [
            "Este es el primer elemento.",
            "Este es el segundo elemento.",
            "Este es el tercer elemento."
        ]
    },
    "layerUnits": {
        "percentile": "percentil",
        "inch": "pulgada",
        "inches": "pulgadas",
        "miles": "millas",
        "sqmi": "millas cuadradas",
        "feet": "pies",
        "sqft": "pies cuadrados",
        "acres": "acres",
        "meters": "metros",
        "count": "cuentas",
        "in": "pulgadas",
        "percent": "%",
        "%": "%",
        "fahrenheit": "°F",
        "F": "°F",
        "dollars": "dólares",
        "gal": "galones",
        "tons": "toneladas",
        "years": "años",
        "coordinate": "coordinar",
        "in/hr": "pulgadas/hora"
    },
    "roles": {
        "workshopAdmin": "Administrador",
        "editor": "Editor",
        "contributor": "Contribuidor",
        "viewer": "Espectador",
        "guest": "Invitado",
        "workshopAdminTooltip": "Puedes crear y editar sitios, agregar remedios y dejar comentarios. También puedes invitar y eliminar colaboradores y administrar sus roles.",
        "editorTooltip": "Puedes crear y editar sitios, agregar remedios y dejar comentarios. También puedes invitar colaboradores.",
        "contributorTooltip": "Puedes agregar remedios y dejar comentarios.",
        "viewerTooltip": "Puedes ver sitios y reaccionar a los remedios."
    },
    "drawEvents": {
        "start": "Haga clic para añadir puntos y dibujar su ubicación.",
        "sketchReadyToClose": "Haz clic en cualquiera de los puntos finales en cualquier momento para completar la forma y crear tu ubicación.",
        "edit": "Edite su ubicación añadiendo, eliminando y moviendo los puntos.",
        "resize": "Haz clic y arrastra cualquier punto para escalar tu ubicación.",
        "editFootprint": "Agrega, elimina y mueve puntos para editar tu huella de remediación.",
        "rotateFootprint": "Haz clic y arrastra para rotar tu huella.",
        "resizeFootprint": "Haz clic y arrastra cualquier punto para escalar tu huella."
    },
    "opportunityRanks": {
        "Very High": "Muy Altas",
        "High": "Altas",
        "Moderate": "Moderadas",
        "Low": "Bajas",
        "Very Low": "Muy Bajas",
        "Unknown": "Desconocido",
        "Very HighOpportunity": "Oportunidades Muy Altas",
        "HighOpportunity": "Oportunidades Altas",
        "ModerateOpportunity": "Oportunidades Moderadas",
        "LowOpportunity": "Oportunidades Bajas",
        "Very LowOpportunity": "Oportunidades Muy Bajas",
        "UnknownOpportunity": "No hay datos disponibles"
    },
    "referenceContentType": {
        "remedy": "remedios",
        "effect": "beneficios",
        "dataLayer": "Capas de datos"
    },
    "UITabs": {
        "benefitsCosts": "Beneficios y Costos",
        "pairings": "Pares",
        "tipsResources": "Consejos y Recursos",
        "remedies": "Remedios",
        "dataLayers": "Capas de datos",
        "documentation": "Documentación",
        "tips": "Consejos",
        "benefits": "Beneficios",
        "conditions": "Condiciones",
        "details": "Detalles",
        "sites": "Ubicaciones",
        "layers": "Capas",
        "summary": "Resumen"
    },
    "footprintPlacements": {
        "aboveground": "sobre el suelo",
        "belowground": "subterráneo",
        "canopy": "dosel",
        "ground": "suelo"
    }
}
